import { mountGlobalPresence } from "./components/global-presence";
import { mountFormSelects } from "./components/form-select";
import { mountFormDesign } from "./components/form-design";
import { mountStatisticCounters } from "./components/statistic-counters";
import { mountHome } from "./pages/home";
import { mountAuth } from "./components/auth";
import { mountServiceStacks } from "./components/service-stack";
import { mountClosingExpand } from "./components/closing-expand";
import { mountTestimonialVideos } from "./components/testimonial-videos";
import { mountHeroDots } from "./components/hero-dots";
import { mountLeadChat } from "./components/lead-chat";
import { mountStudio } from "./components/SolufyStudio";
import { mountAccordions } from "./components/accordion";
import { mountMotionScroll } from "./components/MotionScroll";
import { mountCareersApplication } from "./components/CareersApplicationModal";
import { mountJellyTheme } from "./components/JellyTheme";
import { mountChromaGrid } from "./components/ChromaGrid";
import { mountTheme } from "./components/theme";
import { mountBorderGlow } from "./components/border-glow";
import { mountBlurGradientHeadings } from "./components/blur-gradient-heading";
import { mountArticleToc } from "./components/article-toc";
import { mountPagination } from "./components/pagination";
import { mountIndustryNavigation } from "./components/industry-navigation";
import { mountIndustryClients } from "./components/industry-clients";
import { mountServicesPage } from "./pages/service";
import { mountWebsitePopup } from "./components/website-popup";
import { mountTracker } from "./components/tracker";
import { mountCookieBanner } from "./components/cookie-banner";
import { mountPageAtmosphere } from "./components/page-atmosphere";
import { mountMobileServiceCarousel } from "./components/mobile-service-carousel";
import GradientWaves, { mountGradientWaves } from "./components/GradientWaves";

window.solufy_website = window.solufy_website || {};
window.solufy_website.ui = window.solufy_website.ui || {};
window.solufy_website.GradientWaves = GradientWaves;
window.solufy_website.ui.mount_home = mountHome;
window.solufy_website.ui.mount_accordions = mountAccordions;
window.solufy_website.ui.mount_motion_scroll = mountMotionScroll;
window.solufy_website.ui.mount_careers_application = mountCareersApplication;
window.solufy_website.ui.mount_theme = mountTheme;
window.solufy_website.ui.mount_services_page = mountServicesPage;
window.solufy_website.ui.mount_gradient_waves = mountGradientWaves;
window.solufy_website.tracker = { mountTracker };

const boot = () => {
	mountFormDesign(document);
	mountFormSelects(document);
	mountLeadChat(document);
	mountStatisticCounters(document);
	mountAuth(document);
	mountServiceStacks(document);
	mountClosingExpand(document);
	mountTestimonialVideos(document);
	mountHeroDots(document);
	mountStudio(document);
	mountMobileServiceCarousel(document);
	mountPageAtmosphere(document);
	mountTracker();
	mountCookieBanner(document);
	document.querySelectorAll("[data-solufy-home]").forEach(mountHome);
	mountTheme(document);
	mountGlobalPresence(document);
	mountBorderGlow(document);
	mountAccordions(document);
	mountCareersApplication(document);
	mountServicesPage(document);
	mountBlurGradientHeadings(document);
	mountMotionScroll(document);
	mountChromaGrid(document);
	mountGradientWaves(document);
	mountArticleToc(document);
	mountPagination(document);
	mountIndustryNavigation(document);
	mountIndustryClients(document);
	mountWebsitePopup(document);
};

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
	boot();
}
